import request from "../utils/request";

export function login(code) {
  return request({
    url: "/login/index",
    params: { code },
  });
}

// 获取权限信息
export function getPermission() {
  return request({
    url: "/index/get_OpenIdAccess_list",
    params: {
      limit: "all",
    },
  });
}
